import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Valentina R.',
  text: 'Tenía muchas dudas porque mi piel es súper sensible y había escuchado historias de tratamientos dolorosos. Desde la primera sesión me hicieron sentir tranquila y el láser Soprano fue mucho más cómodo de lo que imaginaba. Ya voy por la cuarta sesión y la diferencia es impresionante. Lo recomiendo totalmente.',
  rating: 5
}, {
  name: 'Martín S.',
  text: 'Después de probar varios métodos que no me daban resultados duraderos, decidí empezar el tratamiento en espalda y pecho. A partir de las primeras sesiones ya noté menos crecimiento y hoy prácticamente no tengo que preocuparme por el vello. Además, la atención es excelente y el lugar transmite mucha confianza.',
  rating: 5
}, {
  name: 'Camila G.',
  text: 'Lo que más me gustó fue el seguimiento personalizado. Siempre están pendientes de cómo responde tu piel y te explican cada paso del proceso. Desde el primer día me sentí acompañada y los resultados fueron exactamente lo que esperaba. Todo muy profesional y transparente.',
  rating: 5
}];
export const Testimonials = () => {
  return <section className="py-12 sm:py-20 bg-brand-50" data-id="element-240">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-241">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-242">
          <h2 className="text-2xl sm:text-3xl font-bold text-navy-900 mb-4" data-id="element-243">
            Lo que dicen nuestros pacientes
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-244">
            La confianza de quienes ya nos eligieron es nuestra mejor garantía.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-245">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-brand-100 relative" data-id="element-246">
              <div className="flex gap-1 mb-6" data-id="element-247">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-yellow-400 text-yellow-400" data-id="element-248" />)}
              </div>
              <p className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-249">
                "{testimonial.text}"
              </p>
              <div className="font-bold text-navy-900" data-id="element-250">{testimonial.name}</div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};